import React, { Component } from 'react'
import { connect } from 'react-redux'

import CharacterDropIn from './CharacterDropIn'

class MessageList extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        let target = this.props[this.props.store_value]
        if ( target ) {
            let _ret = []
            switch(this.props.store_value) {
                case 'messages':
                    for (var item in target) {
                        _ret.push(
                            <CharacterDropIn key={item} value={target[item]} />
                        )
                    }
                    break
                case 'firewalld':
                    for (var item in target) {
                        let ret = "REJECT: " + target[item].dpt + "/" + target[item].proto + " "
                        try {
                            ret += target[item].loc.time_zone
                        } catch(err) {
                            ret += 'unknown'
                        }
                        _ret.push(
                            <CharacterDropIn key={item} value={ret} />
                        )
                    }
                    break
            }
            return (
                <div>
                    <div>
                        {_ret}
                    </div>
                </div>
            )
        } else {
            return ( <div /> )
        }
    }
}

function mapStateToProps(state) {
    return {
        messages: state.messages._buffer,
        firewalld: state.firewalld._buffer
    }
}

export default connect(mapStateToProps)(MessageList)



// WEBPACK FOOTER //
// ./src/components/MessageList.js